import { PERSON } from '../../appConfig'

const PROF = PERSON.prof;
const LASTNAME = PERSON.lastname;
const NAME = PERSON.name;
const PHONE = PERSON.phone;

export {
  PROF,
  LASTNAME,
  NAME,
  PHONE
};
